import { render } from "./InvoiceJobReference.vue?vue&type=template&id=41a353b5&scoped=true"
import script from "./InvoiceJobReference.vue?vue&type=script&lang=js"
export * from "./InvoiceJobReference.vue?vue&type=script&lang=js"

import "./InvoiceJobReference.vue?vue&type=style&index=0&id=41a353b5&scoped=true&lang=css"

import exportComponent from "C:\\mgtspl\\mgtspl\\MGTSPL_FE\\MGTSPL\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a353b5"]])

export default __exports__